import React from 'react';
import { connect } from 'react-redux';
import { createPartner } from './actions';
import PartnerForm from './PartnerForm';

class PartnerCreate extends React.Component{
    onSubmit = formValues => {
        this.props.createPartner(formValues);
    }

    render () {
        return (
            <div>
                <h3>Crear un Socio</h3>
                <PartnerForm onSubmit={this.onSubmit}/>
            </div>
        );
    }
}

export default connect(null, { createPartner })(PartnerCreate);